// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CompletedInvoiceModal_overlay__fC0KW {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.CompletedInvoiceModal_modal__Y7uSS {
  background-color: #fff;
  border-radius: 12px;
  width: 400px;
  max-width: 90%;
  padding: 30px 25px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  position: relative;
  animation: CompletedInvoiceModal_fadeIn__kQZNO 0.2s ease-in-out;
}

@keyframes CompletedInvoiceModal_fadeIn__kQZNO {
  from {
    opacity: 0;
    transform: translateY(-15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.CompletedInvoiceModal_modal__Y7uSS h2 {
  margin: 0 0 20px;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  color: #333;
}

.CompletedInvoiceModal_modal__Y7uSS label {
  display: block;
  margin: 12px 0 6px;
  font-size: 14px;
  color: #555;
}

.CompletedInvoiceModal_modal__Y7uSS input[type="date"],
.CompletedInvoiceModal_modal__Y7uSS select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: border 0.2s;
}

.CompletedInvoiceModal_modal__Y7uSS input[type="date"]:focus,
.CompletedInvoiceModal_modal__Y7uSS select:focus {
  border-color: #4caf50;
}

.CompletedInvoiceModal_actions__VtPCH {
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}

.CompletedInvoiceModal_actions__VtPCH button {
  flex: 1 1;
  padding: 10px 15px;
  font-size: 14px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.CompletedInvoiceModal_actions__VtPCH button + button {
  margin-left: 10px;
}

.CompletedInvoiceModal_pay__61AYG {
  background-color: rgba(29, 135, 82, 1);
  color: #fff;
}

.CompletedInvoiceModal_pay__61AYG:hover {
  background-color: rgba(29, 135, 82, 0.626);
}

.CompletedInvoiceModal_later__GUBiz {
  background-color: #f1f1f1;
  color: #333;
}

.CompletedInvoiceModal_later__GUBiz:hover {
  background-color: #e0e0e0;
}

.CompletedInvoiceModal_close__B\\+Gfd {
  position: absolute;
  top: 12px;
  right: 15px;
  font-size: 20px;
  font-weight: bold;
  color: #999;
  cursor: pointer;
  transition: color 0.2s;
}

.CompletedInvoiceModal_close__B\\+Gfd:hover {
  color: #333;
}
`, "",{"version":3,"sources":["webpack://./src/pages/tables/CompletedInvoiceModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,+DAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal {\n  background-color: #fff;\n  border-radius: 12px;\n  width: 400px;\n  max-width: 90%;\n  padding: 30px 25px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n  position: relative;\n  animation: fadeIn 0.2s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-15px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.modal h2 {\n  margin: 0 0 20px;\n  font-size: 22px;\n  font-weight: 600;\n  text-align: center;\n  color: #333;\n}\n\n.modal label {\n  display: block;\n  margin: 12px 0 6px;\n  font-size: 14px;\n  color: #555;\n}\n\n.modal input[type=\"date\"],\n.modal select {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 14px;\n  outline: none;\n  transition: border 0.2s;\n}\n\n.modal input[type=\"date\"]:focus,\n.modal select:focus {\n  border-color: #4caf50;\n}\n\n.actions {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 25px;\n}\n\n.actions button {\n  flex: 1;\n  padding: 10px 15px;\n  font-size: 14px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.actions button + button {\n  margin-left: 10px;\n}\n\n.pay {\n  background-color: rgba(29, 135, 82, 1);\n  color: #fff;\n}\n\n.pay:hover {\n  background-color: rgba(29, 135, 82, 0.626);\n}\n\n.later {\n  background-color: #f1f1f1;\n  color: #333;\n}\n\n.later:hover {\n  background-color: #e0e0e0;\n}\n\n.close {\n  position: absolute;\n  top: 12px;\n  right: 15px;\n  font-size: 20px;\n  font-weight: bold;\n  color: #999;\n  cursor: pointer;\n  transition: color 0.2s;\n}\n\n.close:hover {\n  color: #333;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `CompletedInvoiceModal_overlay__fC0KW`,
	"modal": `CompletedInvoiceModal_modal__Y7uSS`,
	"fadeIn": `CompletedInvoiceModal_fadeIn__kQZNO`,
	"actions": `CompletedInvoiceModal_actions__VtPCH`,
	"pay": `CompletedInvoiceModal_pay__61AYG`,
	"later": `CompletedInvoiceModal_later__GUBiz`,
	"close": `CompletedInvoiceModal_close__B+Gfd`
};
export default ___CSS_LOADER_EXPORT___;
